// Ping corto de dos tonos hecho con Web Audio: no hay archivo de audio que cargar ni licenciar.
// Los navegadores no dejan sonar hasta que el usuario haya interactuado con la página; antes
// de eso el contexto queda suspendido y el aviso visual sigue siendo el único. Un fallo de
// audio nunca debe romper la página, por eso se traga todo.
let context = null;

function getContext() {
  if (!context) {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) {
      return null;
    }
    context = new AudioContextClass();
  }
  return context;
}

const TONES = [
  { frequency: 880, offset: 0 },
  { frequency: 1175, offset: 0.15 },
];

const GESTURES = ['pointerdown', 'keydown'];
let unlockArmed = false;

// Los navegadores solo dejan sonar un contexto creado o reanudado durante un gesto del usuario;
// crearlo recién cuando llega el mensaje lo deja suspendido y el ping no se oye. Se arma una
// vez y en el primer clic o tecla de la página crea y reanuda el contexto compartido.
export function unlockNotificationSound() {
  if (unlockArmed) {
    return;
  }
  unlockArmed = true;

  const unlock = () => {
    GESTURES.forEach((gesture) => document.removeEventListener(gesture, unlock, true));
    try {
      const audio = getContext();
      if (audio && audio.state === 'suspended' && audio.resume) {
        audio.resume();
      }
    } catch (error) {
      // sin audio, queda el aviso visual
    }
  };
  GESTURES.forEach((gesture) => document.addEventListener(gesture, unlock, true));
}

export default function playNotificationSound() {
  try {
    const audio = getContext();
    if (!audio) {
      return;
    }
    if (audio.state === 'suspended' && audio.resume) {
      audio.resume();
    }

    const now = audio.currentTime;
    const gain = audio.createGain();
    gain.connect(audio.destination);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.25, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.45);

    TONES.forEach(({ frequency, offset }) => {
      const oscillator = audio.createOscillator();
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(frequency, now + offset);
      oscillator.connect(gain);
      oscillator.start(now + offset);
      oscillator.stop(now + offset + 0.25);
    });
  } catch (error) {
    // sin audio, queda el aviso visual
  }
}
